export default __webpack_public_path__ + "static/media/fondo.1524eb07.png";